import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Alhamdulillah</h3>
            <p>{t('footer.tagline')}</p>
          </div>
          <div className="footer-section">
            <h4>{t('footer.legal')}</h4>
            <ul>
              <li><Link to="/eula">{t('footer.eula')}</Link></li>
              <li><Link to="/privacy">{t('footer.privacy')}</Link></li>
              <li><Link to="/terms">{t('footer.terms')}</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>{t('footer.languages')}</h4>
            <p>{t('footer.appAvailable')}</p>
            <p>English • Français • العربية</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Alhamdulillah. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
